import React from 'react';
import { Box, Chip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import TooltipWrapper from '../TooltipWrapper';

const useStyles = makeStyles(theme => ({
  users: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  userChip: {
    marginRight: theme.spacing(1),
    [`${theme.breakpoints.down('lg')}`]: {
      marginRight: 0,
      fontSize: theme.spacing(1.25),
      height: theme.spacing(2.5),
    },
  },
}));

const UserChips = ({ event }) => {
  const classes = useStyles();

  return (
    event.allocatedStaff?.length > 0 && (
      <Box sx={{ display: 'flex' }}>
        {event.allocatedStaff.map(allocation => (
          <TooltipWrapper
            key={allocation.user._id}
            title={`${allocation.user.firstName} ${allocation.user.lastName}`}
          >
            <Chip
              variant="outlined"
              size="small"
              label={`${allocation.user.firstName} ${allocation.user.lastName}`}
              color="primary"
              className={classes.userChip}
            />
          </TooltipWrapper>
        ))}
      </Box>
    )
  );
};

export default UserChips;
